import React from "react";

import { AVAILABLE_LANGS } from "@typings/globals";

import { useTranslate } from "@hooks/useTranslate";
import { useAuth } from "@hooks/useAuth";
import { useFeatureToggleManager } from "@hooks/useFeatureToggle";

import { TypeOfUser } from "../../typings/typeOfUser";

import { Link } from "./useAccountNav.types";
import { getLinks } from "./useAccountNav.helpers";

export const useAccountNav = (language: AVAILABLE_LANGS): Link[] => {
  const translate = useTranslate();
  const { isUserLoggedIn, isUserClient } = useAuth();
  const { config } = useFeatureToggleManager();

  const hiddenFor: TypeOfUser = isUserClient ? "client" : "agent";
  const links = getLinks(language, translate);

  const filteredLinks = !isUserLoggedIn
    ? []
    : links
        .filter(link => link.hiddenFor !== hiddenFor)
        .filter(link => {
          if (link.hiddenForFeature) {
            return !config[link.hiddenForFeature];
          }
          return true;
        });

  return filteredLinks;
};
